import { Skeleton } from "primereact/skeleton";
import { formatTimeToComplete } from "sj-ui-toolkit/src/utils";

export function PathDurationColumn({ rowData, loading }) {
  if (loading) return <Skeleton />;

  return (
    <div className="flex flex-col body-sm">
      <span className="text-muted-aaa">Path Duration</span>
      <span>
        <i className="pi pi-clock text-xs mr-[8px]" />
        {formatTimeToComplete(rowData.timeSpent)}
      </span>
    </div>
  );
}
